// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Jtf3l","signatureButtonsRight":"ModalSign_signatureButtonsRight__3dDwK"};